<template>
  <div class="card is-min-width-500">
    <header class="bandeau-modal card-header"></header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('listeParution.popUpValidationDate.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div v-if="parutionCopy" class="card-content">
      <error-msg-component
        v-if="error"
        :messages="messages"
        :error="error"
        :champs-vide="champsVide"
        :messages-champs-vide="messagesChampsVide"
        @close="error = $event"
        class="mgt-20px"
        title="general.problemOccurred"
        withEmplyFields/>
      <div class="columns is-multiline is-vcentered">
        <b-field
          :label="$t(`listeParution.tab.${typeDate}`)"
          class="column is-6 mgb-0">
          <div class="columns is-vcentered" >
            <b-datepicker
              v-model="parutionCopy[typeDate]"
              class="column"
              icon="calendar-today"
              position="is-bottom-right"
              editable
              nearby-selectable-month-days
              show-week-number>
            </b-datepicker>
          </div>
        </b-field>
        <b-field class="column is-6 mgb-0 bfieldWhitoutLabel">
          <b-checkbox
            v-model="parutionCopy[typeDateDefinitif]">
            {{ $t('listeParution.popUpValidationDate.dateDefinitif') }}
          </b-checkbox>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="save">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { update } from '@/api/presse/parution';
import messageSucces from '@/services/general/messageSucces';
import validationGeneral from '@/services/validation/validation';
import validationParution from '@/services/presse/parution/validationParution';
import translate from '@/services/presse/parution/translatorParution';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { TYPE_DATES_DEFINITIF } from '@/configuration/presse/parution/parutionConfig';
import moment from 'moment';
import formatDate from '@/services/general/formatIsoDate';

export default {
  props: {
    typeDate: {
      type: String,
      required: true,
    },
    parution: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      error: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      parutionCopy: null,
    };
  },
  computed: {
    typeDateDefinitif() {
      return TYPE_DATES_DEFINITIF[this.typeDate];
    },
  },
  methods: {
    async save() {
      this.error = false;
      this.messages = [];
      this.messagesAvertissement = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        const parutionToUpdate = cloneDeep(this.parutionCopy);
        parutionToUpdate[this.typeDate] = formatDate(parutionToUpdate[this.typeDate]);
        await update(parutionToUpdate);
        messageSucces(this.$i18n.t('addEditParution.notifications.successChange'));
        this.$emit('is-update');
        this.$parent.close();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationParution(e.response, this.messages, this.$i18n, translate);
          this.error = true;
          return;
        }
        throw e;
      }
    },
  },
  mounted() {
    const parutionCopy = cloneDeep(this.parution);
    parutionCopy[this.typeDate] = moment(parutionCopy[this.typeDate]).toDate();
    this.parutionCopy = parutionCopy;
  },
};
</script>
